import React, { useContext } from "react";
import { isNil } from "ramda";

import { ExecuteButton } from "affinityForm/components/executeButton";
import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { ButtonGroup } from "affinityUI/form/components";

import { PatientsFormContext } from "../patientFormContext";

import PatientSummary from "./patientSummary";

export const PatientConfirmation: React.FC = () => {
  const formContext = useContext(PatientsFormContext);
  const patient = formContext?.formData;

  if (!isNil(patient)) {
    return (
      <Card>
        <PatientSummary formLink=".." patient={patient} />
        <ButtonGroup>
          <NavigateButton variant={ButtonVariants.SECONDARY} to="../..">
            Cancel
          </NavigateButton>
          <ExecuteButton>Confirm and save patient info</ExecuteButton>
        </ButtonGroup>
      </Card>
    );
  } else {
    return <>Error...</>;
  }
};
